<template>
  <div class="app">
    <!-- 头部开始 -->
    <div class="header" style="height: 0px"></div>
    <!-- 头部结束 -->

    <!-- 容器开始 -->
    <div
      class="container"
      @click="mouseClick($event)"
      @mousemove="mouseMove($event)"
      @contextmenu="rightClick($event)"
    >
      <!-- giscore开始 -->
      <div id="giscoreContainer">
        <!-- 顶部工程信息 -->
        <div class="title-info" v-if="phoneFlag == false">
          <div class="top-project">
            <div class="l-title">长沙县支一路（望仙路-特立路）工程总承包</div>
            <div class="r-info">
              <span class="m-r-24">项目经理：李件军</span>
              <span>联系电话：17267314906</span>
            </div>
          </div>
        </div>
        <!-- 卡片信息开始 -->
        <!-- pc端 -->
        <CardInfo v-if="cardInfoFlag"></CardInfo>
        <!-- 移动端 -->
        <PhoneCardInfo
          ref="phoneCardInfoId"
          v-show="phoneCardInfoFlag"
        ></PhoneCardInfo>
        <!-- 卡片信息结束 -->

        <!-- 管道水位模拟卡片开始 -->
        <pwSet ref="pwSetId" v-show="isShowPWSettingBox"></pwSet>
        <!-- 管道水位模拟卡片结束 -->
        <!-- 模型剖切卡片开始 -->
        <cmSet ref="cmSetId" v-show="isShowCMSettingBox"></cmSet>
        <!-- 模型剖切卡片结束 -->
        <!-- 资源加载提示卡片开始 -->
        <lmInfo ref="lmInfoId" v-show="isShowLoadModelBox"></lmInfo>
        <!-- 资源加载提示卡片结束 -->
      </div>
      <!-- giscore结束 -->
      <!-- 属性panel开始 -->
      <div :class="phoneFlag == true ? 'phonePanel' : 'panel'">
        <!-- <div class="title">构件详情</div>
        <div class="panel-body">
          <div class="panel-tips">"请选择一个构件，以查看属性"</div>
          <div class="panel-container scroll-bar">
            <table class="panel-table"></table>
          </div>
        </div> -->
        <div
          v-if="phoneFlag == false"
          class="close"
          onclick="let panel = document.querySelector('.panel');panel.style.display = panel.style.display == 'block' ? 'none' : 'block';"
        >
          X
        </div>
        <div v-if="phoneFlag == true" class="close" @click="closePhone">X</div>
        <!-- 返回检查井周边 -->
        <div @click="handleBackWell()" class="backs">返回</div>
        <div
          v-show="openType == 'null'"
          style="
            color: #fff;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          "
        >
          正在查询中...
        </div>
        <ProductInfo
          ref="constructIds"
          v-show="openType == 'pipe'"
        ></ProductInfo>
        <!-- 检查井周边 -->
        <WellInfo ref="wellInfoId" v-show="openType == 'well'"></WellInfo>
        <div class="resize"></div>
      </div>
      <!-- 属性panel结束 -->
      <!-- toolbar-tree开始-->
      <div class="toolbar toolbar-tree"></div>
      <!-- toolbar-tree结束-->
    </div>

    <!-- 显隐按钮开始 -->
    <el-checkbox-group
      ref="showCheck"
      v-show="isShowCheckbox"
      v-model="checkboxGroup"
      size="mini"
      style="position: absolute; bottom: 100px; left: 0; right: 0; z-index: 999"
    >
      <el-checkbox-button
        v-for="model in modelOptions"
        :label="model"
        :key="model"
        style="margin: 1px"
        @change="showModel()"
        >{{ model }}</el-checkbox-button
      >
    </el-checkbox-group>
    <!-- 显隐按钮结束 -->

    <!-- 设置按钮开始 -->
    <el-checkbox-group
      ref="settingCheck"
      v-show="isShowSettingbox"
      v-model="settingboxGroup"
      size="mini"
      style="position: absolute; bottom: 100px; left: 0; right: 0; z-index: 999"
    >
      <el-checkbox-button
        v-for="setting in settingOptions"
        :label="setting"
        :key="setting"
        style="margin: 1px"
        @change="clickSetting()"
        >{{ setting }}</el-checkbox-button
      >
    </el-checkbox-group>
    <!-- 设置按钮结束 -->

    <!-- 提示窗口开始 -->
    <el-dialog
      :title="dialogText[0]"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <span>{{ dialogText[1] }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 提示窗口结束 -->

    <!-- 容器结束 -->
  </div>
</template>

<style scoped>
@import url('../../public/static/css/index.css');
@import url('../../public/static/css/toolbar.css');
@import url('../../public/static/css/panel.css');
</style>

<script>
import { PipeInfo } from "../assets/static/js/getPipeInfo"
import { UI } from '../../public/static/extend/UI'
import * as Cesium from 'cesium'
import { GisCore } from "giscore"
import { config } from 'giscore/giscore.config'
import { GET_PIPE_LIST, GET_WELL_LIST } from "@/apis/gis"
import 'cesium/Source/Widgets/widgets.css'
import { nextTick } from 'vue'
const CardInfo = () => import('@/components/cardInfo/index'); //卡片信息组件
const PhoneCardInfo = () => import('@/components/phoneCardInfo/index'); //移动端卡片信息组件
const ProductInfo = () => import('@/components/lifeCycle/index'); //产品信息组件
const WellInfo = () => import('@/components/lifeCycle/wellInfo'); //检查井周边组件
const pwSet = () => import('@/components/pipeWaterSet/index'); //水位模拟组件
const cmSet = () => import('@/components/cutModelSet/index'); //模型剖切组件
const lmInfo = () => import('@/components/loadModelInfo/index'); //模型剖切组件
let modelOptions = [];
let settingOptions = ['统计数据', '模型剖切', '管道水位模拟', '视角锁定管道', '显示管内底埋深', '隐藏侧边栏', '全屏显示'];
export default {
  name: '',
  // 监听属性 类似于data概念
  computed: {

  },
  components: {
    CardInfo, PhoneCardInfo, ProductInfo, WellInfo, pwSet, cmSet, lmInfo
  },
  data () {
    return {
      isGetAxis: false, //是否开启控制台输出鼠标点击经纬度信息
      isDig: false, //是否开启挖地模式
      isShowCheckbox: false, //构件显隐窗口显示
      isShowPWSettingBox: false, //设置水位模拟窗口显示
      isShowCMSettingBox: false, //设置模型剖切窗口显示
      isShowLoadModelBox: true,
      isCutModel: false, //设置模型剖切
      isFullScreen: false,//是否全屏
      checkboxGroup: [], //构件显隐按钮组
      modelOptions: modelOptions, //构件显隐按钮
      isShowSettingbox: false, //设置窗口显示
      settingboxGroup: [], //设置按钮组
      settingOptions: settingOptions, //设置按钮
      settingBoolDict: undefined, //存储各个设置当前布尔值
      openType: '',
      cardInfoFlag: false,
      phoneCardInfoFlag: false,
      phoneFlag: false,
      wellData: {},
      dialogVisible: false,
      dialogText: ['提示', ''],
      mouseAxisList: [],
      pipeDeep: {
        'Y01': '[1.99,1.97]', 'Y02': '[1.93,1.92]', 'Y03': '[1.84,1.83]', 'Y04': '[1.77,1.76]',
        'Y05': '[1.81,1.81]', 'Y06': '[1.9,1.91]', 'Y07': '[1.98,1.99]', 'Y08': '[2.09,2.08]', 'Y09': '[1.86,1.82]',
        'Y10': '[1.69,1.79]', 'Y11': '[1.92]', 'Y12': '[2.05]', 'W1-1': '[2.66]', 'W1': '[2.66]',
        'W2': '[2.75,2.76]', 'W3-1': '[2.76,2.76]', 'W3': '[2.76,2.76]', 'W4': '[2.58,2.55]', 'W5': '[2.32,2.29]', 'W6': '[2.34]'
      },
      waterDirection: [['Y01', 'Y02', 'Y03', 'Y04', 'Y05', 'Y06', 'Y07', 'Y08', 'Y09', 'Y10', 'Y11', 'Y12'],
      ['W1', 'W2', 'W3', 'W4', 'W5', 'W6'],
      ['W1-1', 'W1'],
      ['W3-1', 'W3']],
      cityAxiz: [113.12098820449636, 28.256150218457687, 26],
      cityCutAxiz: [
        [
          113.12142552716101,
          28.25764444173175
        ],
        [
          113.12101500404785,
          28.25764444173175
        ],
        [
          113.12101500404785,
          28.25431763870921
        ],
        [
          113.12142552716101,
          28.25431763870921
        ]
      ],
      cityModelUrl: '../../assets/gltf/长沙项目项目周边模型.glb',
      roadModelUrl: '../../assets/gltf/长沙项目项目道路模型.glb',
      pipeModelUrl: '../../assets/gltf/pipeModel.glb'

    }
  },

  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    // 是否挖地
    window.isDig = true;
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.$nextTick(function () {
      if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
        // 当前设备是移动设备
        this.phoneFlag = true;
        this.cardInfoFlag = false;
        this.phoneCardInfoFlag = true;
      } else {
        this.phoneFlag = false;
        this.cardInfoFlag = true;
        this.phoneCardInfoFlag = false;
      }
    })
    this.init();

    // 属性窗口初始化
    window['clearPanel'] = () => {
      this.closePanel();
    }

    // 管道详情
    window['passPipe'] = (constructId) => {
      this.getDetail(constructId, 'pipe');
    }
    // 检查井详情
    window['passWell'] = (wellName) => {
      this.getDetail(wellName, 'well');
    }


  },

  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { },
  // 方法集合
  methods: {

    /**
 * GIS引擎初始化
 */
    init () {
      // 首先检查用户浏览器是否为推荐浏览器
      if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
        // 当前设备是移动设备
        this.phoneCardInfoFlag = false;
      } else {
        // 检测是否支持webGL
        const canvas = document.createElement("canvas");
        const gl =
          canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
        if (gl && gl instanceof WebGLRenderingContext) {
          // 浏览器支持 WebGL
        } else {
          // 浏览器不支持 WebGL
          alert("浏览器不支持webGl，请升级浏览器！");
        }

        let checkAgent = this.checkAgent();
        if (checkAgent) {
          this.warnGpu();
        }
      }

      let that = this;

      // 实例化获取管道信息类
      this.pipeInfo = new PipeInfo();

      // 模型列表初始化
      let models = []

      // 初始化GisCore

      //  配置giscore的token
      let accessToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJhZjNjZjBlNC03NmFiLTQ2YjgtYmZhZC0wY2QwY2IxNmUxYWMiLCJpZCI6MTc1NzkyLCJpYXQiOjE3MDQ0MzU4OTB9.wphDRUr7J7LRUHRxsYaPk7mbz-0Ct9czww9lsbRGi_E";
      // 初始化giscore
      let gisCore = new GisCore(config, accessToken);
      gisCore.init("giscoreContainer");
      window.gisCore = gisCore;
      let viewer = window.viewer;

      // 初始化工具栏
      this.ui = new UI();
      //工具栏参数
      let opt = [
        {
          title: '主视角',
          url: 'url(../static/img/ui/zhushijiao.png)',
          callback: () => {
            gisCore.position.buildingPosition(viewer, [112.9870172800011, 28.22787655428849, 20000000], 0, -90, 3);
          }
        },
        {
          title: '定位',
          url: 'url(../static/img/ui/shiqumian.png)',
          callback: () => {
            window.initPos == null ? gisCore.position.buildingPosition(viewer, [112.9870172800011, 28.22787655428849, 20000000]) : gisCore.position.buildingPosition(viewer, ...window.initPos)

          }
        },
        {
          title: '挖地',
          url: 'url(../static/img/ui/zhongli@2x.png)',
          callback: () => {
            window.isDig = !window.isDig;
          }
        },
        {
          title: '显隐',
          url: 'url(../static/img/ui/xitongin@2x.png)',
          callback: () => {
            window.isShowCheckbox = !window.isShowCheckbox;
          }
        },
        {
          title: '更多',
          url: 'url(../static/img/ui/shezhi.png)',
          callback: () => {
            window.isShowSettingbox = !window.isShowSettingbox;
          }
        },

      ]
      // 初始化UI组件
      this.ui.init(document.querySelector('#giscoreContainer'), opt);


      // 视角初始化
      gisCore.position.buildingPosition(viewer, [113.12380548015745, 28.250758831850005, 700], -20, -45, 1);
      window.initPos = [[113.12380548015745, 28.250758831850005, 700], -20, -45, 1];

      // 关闭地面深度测试，露出里面的模型
      viewer.scene.globe.depthTestAgainstTerrain = false;

      // 光照设置
      viewer.scene.globe.enableLighting = false;
      viewer.shadows = false
      viewer.scene.light = new Cesium.DirectionalLight({
        direction: new Cesium.Cartesian3(0.354925, -0.890918, -0.283358)
      })

      // 地形挖取
      gisCore.model.dig([113.12123548015745, 28.255978831850005, 20], [-20, -20, -185, -185])

      // 绑定左键点击事件
      that.leftClickEvent()

      // 帧率显示
      viewer.scene.debugShowFramesPerSecond = true;

      // 分辨率设置
      // viewer.resolutionScale = 0.9; // 默认值为 1.0；

      // 关闭太阳，月亮，天空盒，雾等相关特效
      viewer.scene.moon.show = false;
      viewer.scene.fog.enabled = false;
      viewer.scene.sun.show = false;
      viewer.scene.skyBox.show = false;

      /**
       * 模型初始化
       */
      //  管内底埋深数据
      window.pipeDeep = that.pipeDeep;

      // 询问是否可以挖地
      let askDig = () => {
        setTimeout(() => {
          try {
            // 自动挖地
            that.changeDig();
          } catch (err) {
            askDig();
          }
        }, 1500)
      }

      // 添加城市模型
      that.addCityModel().then(async () => {
        await nextTick();
        askDig();
      })





    },

    /**
     * 更多事件方法
     * @param {*} name 
     * @param {*} bool 
     */
    updateSetting (name, bool) {
      switch (name) {
        case ('统计数据'): {
          // 统计名称
          let calcName = [
            '雨水管道',
            '污水管道',
            '雨水检查井',
            '污水检查井',
            '雨水口']

          // 构造零数组
          let sumData = new Int32Array(calcName.length);

          this.pipeInfo.getPipeInfo().then(() => {
            var temp = this.pipeInfo.pipeRes;
            temp.forEach((e) => {
              var name = e.name;
              if (name.includes('雨水管')) {
                sumData[0] += 1;
              } else if (name.includes('污水管')) {
                sumData[1] += 1;
              }
              if (name.includes('雨水管检查井')) {
                sumData[2] += 1;
              } else if (name.includes('污水管检查井')) {
                sumData[3] += 1;
              } else if (name.includes('雨水口')) {
                sumData[4] += 1;
              }

            });


            // 构造HTML表格代码
            let htmlData = ''
            htmlData += ('<table border="0" width="230" height="100" cellpadding="15" cellspacing="5" style="margin: auto;">')
            htmlData += ('<tr><th>构件名称</th><th>构件个数</th></tr>')
            calcName.forEach((e, index) => {
              htmlData += (`<tr><td>${e}</td><td>${sumData[index]}</td></tr>`)
            })

            // 展示
            this.$alert(htmlData, '模型构件统计数据', {
              dangerouslyUseHTMLString: true,
              showClose: false,
              center: true
            });

            // 按钮不高亮
            this.settingboxGroup.forEach((e, index) => { if (e === name) { this.settingboxGroup.splice(index, 1) } })
            setTimeout(() => {
              this.settingBoolDict[name] = false;
            })


          });



          break;
        }

        case ('模型剖切'): {
          if (!bool) {
            this.$notify({
              title: '成功',
              message: '模型剖切已重置',
              type: 'success'
            });

            gisCore.model.delLine("PaintLineCollecion");
            gisCore.model.delLine("PaintMoveLineCollecion");
            gisCore.model.digModel(this.cityModel)
            gisCore.model.digModel(this.roadModel)
            this.$refs.cmSetId.endClick();

            // 防止道路模型不在指定位置
            gisCore.model.changeModelPos(this.roadModel, [113.12098820449636, 28.256150218457687, 26], [90, 0, 0])
            this.roadModel.show = true;
          }
          this.isShowCMSettingBox = bool;



          break;
        }

        case ('管道水位模拟'): {
          if (bool) {
            this.pwInterval = setInterval(() => {
              this.showPWLevel(bool, 90);
            }, 800)
          } else {
            this.showPWLevel(bool);
            clearInterval(this.pwInterval);
            this.pwInterval = null;
          }

          this.switchShowCheck('水流流向', bool)
          this.isShowPWSettingBox = bool;
          break;
        }

        case ('视角锁定管道'): {
          // 锁定视角
          gisCore.position.lockTo(window.viewer, bool, [113.12143453385162, 28.256011465656002], 46);
          break;
        }

        case ('显示管内底埋深'): {
          // 开启地下模式
          gisCore.model.undergroundMode(bool);
          // 智能跟随效果关闭显示
          this.switchShowCheck('水流流向', bool)
          this.switchShowCheck('挖地表面', bool)
          // 相机飞行至侧面
          // 改写工具栏toolbar的定位功能
          if (bool) {
            gisCore.position.buildingPosition(window.viewer, [113.12475762289173, 28.25591259348388, 25], -90, 0, 1)
            window.initPos = [[113.12475762289173, 28.25591259348388, 25], -90, 0, 1];
          } else {
            gisCore.position.buildingPosition(window.viewer, [113.12380548015745, 28.250758831850005, 700], -20, -45, 1)
            window.initPos = [[113.12380548015745, 28.250758831850005, 700], -20, -45, 1];
          }
          // 隐藏标签
          gisCore.tip.hideTipById('管内底埋深', !bool);
          // 自动打开视角锁定管道
          this.switchSettingCheck('视角锁定管道', !bool);
          break;
        }

        case ('隐藏侧边栏'): {
          if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
            // 当前设备是移动设备
            this.phoneCardInfoFlag = !bool;
          } else {
            this.cardInfoFlag = !bool;
          }
          break;
        }

        case ('全屏显示'): {
          if (this.isFullScreen) {
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.mozRequestFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.webkitRequestFullscreen) {
              document.webkitCancelFullScreen();
            }
            this.isFullScreen = !this.isFullScreen;
          } else {
            var element = document.documentElement;
            if (element.requestFullscreen) {
              element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
              element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {
              element.webkitRequestFullscreen();
            } else {
              alert("当前浏览器不支持全屏！");
              return false;
            }
            this.isFullScreen = !this.isFullScreen;
          }
          break;
        }


        default: {
          this.$notify({
            title: '提示',
            message: '缺少对' + name + '的配置。',
            type: 'warning'
          });
        }

      }


    },

    /**
     * 添加标签
     * @param {*} pipeModel 
     */
    addTips (pipeModel) {

      return new Promise(async (resolve, reject) => {
        // 管道模型的坐标转换
        let lastPickId = null
        let wellAxiz = {}
        for (var i in pipeModel._pickIds[0]['_pickObjects']) {
          if (!!pipeModel._pickIds[0]['_pickObjects'][i]['detail']?.node.show) {
            let pickObj = pipeModel._pickIds[0]['_pickObjects'][i]
            let temp = pickObj['detail'].node

            // 利用pickID获取管道ID
            let id = pickObj.detail.node._id;
            let pickItem = pickObj.detail.model._loader._gltfJsonLoader._gltf.nodes[id].extras.Parameters.find((e) => { return e.GroupName === "标识数据" })

            // 处理pickItem为undefined的情况
            if (pickItem == undefined) {
              continue;
            }
            let pickID = pickItem['Parameters'][0]['value']

            // 处理pickID重复的情况
            if ((!!lastPickId || lastPickId === 0) && lastPickId == pickID) {
              continue;
            }
            lastPickId = pickID

            try {
              let pickName = await this.pipeInfo.getPipeNameById(pickID)
              if (pickName.slice(3, 6) == '检查井') {
                var axis = gisCore.model.getAxizFromMatrix(pickObj.detail.node._node.matrix, this.cityAxiz, 79.1, 20, [1.015, 2, 1])
                axis[0] += 0.00023
                axis[1] -= 0.00012
                var tipsName = null;
                if (pickName.includes('雨水')) {
                  tipsName = 'Y' + pickName.slice(7)
                  gisCore.tip.createTip('雨水管标签', tipsName, axis, '#0a0caa')
                  gisCore.tip.createTip('管内底埋深', window.pipeDeep[tipsName], [axis[0], axis[1], axis[2] - 5], '#ffcc00', 0)
                } else if (pickName.includes('污水')) {
                  tipsName = 'W' + pickName.slice(7)
                  gisCore.tip.createTip('污水管标签', tipsName, axis, '#c300c4')
                  gisCore.tip.createTip('管内底埋深', window.pipeDeep[tipsName], [axis[0], axis[1], axis[2] - 5], '#ffcc00', 0)
                }
                wellAxiz[tipsName] = axis;
              }
              this.recallFunc()
            } catch (error) {
            }
          }
        }
        resolve(wellAxiz)
      })









    },

    /**
     * 获取详情数据
     * @param {*} val 
     * @param {*} type 
     */
    getDetail (val, type) {
      this.openType = type;
      let that = this;
      let url = type == 'pipe' ? GET_PIPE_LIST : GET_WELL_LIST
      $.ajax({
        url: url,
        contentType: 'application/json',
        type: 'post',
        data: JSON.stringify({
          'constructId': val
        }),
        async: false,
        cache: true,//不保存缓存
        success: function (data) {
          if (data.code == '200') {
            if (type == 'pipe') {
              that.$refs.constructIds.open(data);
            } else {
              that.wellData = data;
              that.$refs.wellInfoId.open(data);
            }
          } else {
            that.$notify({
              title: '提示',
              message: data.msg,
              type: 'warning'
            });
            // 属性窗口创建
            let panels = '';
            if (that.phoneCardInfoFlag) {
              // 当前设备是移动设备
              panels = document.querySelector('.phonePanel');
            } else {
              panels = document.querySelector('.panel');
            }
            panels.style.display = 'none';
          }
        },
        error: function () {
          alert("请求数据失败！");
        }
      });
    },

    /**
     * 返回检查井
     */
    handleBackWell () {
      let backs = '';
      backs = document.querySelector('.backs');
      backs.style.display = 'none';
      this.$refs.wellInfoId.open(this.wellData);
    },

    /**
     * 关闭移动端属性卡片
     */
    closePhone () {
      let panel = document.querySelector('.phonePanel'); panel.style.display = panel.style.display == 'block' ? 'none' : 'block';
      this.phoneCardInfoFlag = true;
      this.$refs.phoneCardInfoId.handleClose();
    },

    closePanel () {
      this.openType = 'null';
    },

    /**
     * 绑定左键事件
     */
    leftClickEvent () {
      window['leftClickEvent'] = (e) => {
        let that = this;

        // 清除高亮颜色
        function clearColor () {
          try {
            window.lastPickModel.detail.node.runtimePrimitives[0].primitive.material.metallicRoughness.baseColorFactor = window.lastColor;
          } catch (error) {

          }

          // try {
          //   window.lastPickModel.primitive.lightColor = window.lastLightColor;
          // } catch (error) {
          // }
        }

        // 高亮选中材质颜色
        function colorSet (pickObj) {
          try {
            console.log(pickObj)
            // 高亮颜色设置
            let highLightColor = "#ee5522"
            let CartesianColor = new Cesium.Cartesian3(Cesium.Color.fromCssColorString(highLightColor).red, Cesium.Color.fromCssColorString(highLightColor).green, Cesium.Color.fromCssColorString(highLightColor).blue);
            pickObj.detail.node.runtimePrimitives[0].primitive.material.metallicRoughness.baseColorFactor = Object.freeze(new Cesium.Cartesian4(CartesianColor.x, CartesianColor.y, CartesianColor.z, 1));
            // pickObj.primitive.lightColor = new Cesium.Cartesian3(Cesium.Color.fromCssColorString(highLightColor).red, Cesium.Color.fromCssColorString(highLightColor).green, Cesium.Color.fromCssColorString(highLightColor).blue);
          } catch (error) {

          }
        }

        // 保存选中材质颜色
        function colorSave (pickObj) {
          try {
            window.lastColor = JSON.parse(JSON.stringify(pickObj.detail.node.runtimePrimitives[0].primitive.material.metallicRoughness.baseColorFactor));
            window.lastPickModel = pickObj;

          } catch (e) {

          }
        }

        // 针对该项目的pipeModel gltf模型
        function pickInfo (pickObj) {
          return new Promise((resolve, reject) => {
            let pickID = null;
            let pickName = null;

            // 利用pickID获取管道ID
            let id = pickObj.detail.node._id;
            let pickItem = pickObj.detail.model._loader._gltfJsonLoader._gltf.nodes[id].extras.Parameters.find((e) => { return e.GroupName === "标识数据" })
            pickID = pickItem['Parameters'][0]['value']

            that.pipeInfo.getPipeNodeNameById(pickID).then((res) => {
              pickName = res;
              resolve([pickID, pickName])
            }).catch(() => {
            })

          })


        }

        function showProps (constructId, wellName) {
          if (wellName == null) {
            // to管道详情
            window.passPipe(constructId);
          } else {
            // to检查井周边
            window.passWell(wellName);
          }
          // 加载出属性则取false
          window.isClearingPanel = false;
        }


        function initProps (pickObj) {

          // 加载空窗
          window.clearPanel();
          // 空窗取true
          window.isClearingPanel = true;

          if (pickObj?.id?.id != '城市白膜' && pickObj?.id?.id != '城市道路') {
            // 属性窗口创建
            let panels = '';
            if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
              // 当前设备是移动设备
              panels = document.querySelector('.phonePanel');
            } else {
              panels = document.querySelector('.panel');
            }
            if (pickObj?.detail?.node?._id != undefined) panels.style.display = 'block'

            // 保存选中材质颜色
            colorSave(pickObj);
            // 高亮选中材质颜色
            colorSet(pickObj);
          }



          if (pickObj?.detail?.node?._id != undefined) {
            pickInfo(pickObj).then((pick) => {
              let pickID = parseInt(pick[0]);
              let pickName = pick[1];

              setTimeout(() => {
                showProps(pickID, pickName)
              })
            })


          }

        }


        /**
         * 主函数
         */
        setTimeout(() => {
          let pickObj;
          let panels = '';
          if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
            // 当前设备是移动设备
            panels = document.querySelector('.phonePanel');
          } else {
            panels = document.querySelector('.panel');
          }

          // 防止用户在加载窗口时误关闭窗口导致高亮bug
          window.isClearingPanel = window.isClearingPanel === undefined ? false : window.isClearingPanel;
          if (!window.isClearingPanel) {
            panels.style.display = 'none'
          }

          // 清除先前高亮
          clearColor()

          // 让水流流向不要干扰点击
          setTimeout(() => {
            // document.querySelectorAll('.el-checkbox-button').forEach((ele) => {
            // if (ele.children[1].innerText === '水流流向' && ele.attributes[2].value != 'el-checkbox-button el-checkbox-button--mini') {
            //   ele.click();
            //   setTimeout(() => {
            //     pickObj = viewer.scene.pick(e.position);
            //     ele.click();
            //     if (Cesium.defined(pickObj)) {
            //       try {
            //         if (!!pickObj) {
            //           initProps(pickObj)
            //         }
            //       }
            //       catch { (err) => { console.log(err); } }
            //     }
            //   }, 100)
            // } else if (ele.children[1].innerText === '水流流向' && ele.attributes[2].value == 'el-checkbox-button el-checkbox-button--mini') {
            //   pickObj = viewer.scene.pick(e.position);
            //   if (Cesium.defined(pickObj)) {
            //     try {
            //       if (!!pickObj) {
            //         initProps(pickObj)
            //       }
            //     }
            //     catch { (err) => { console.log(err); } }
            //   }
            // }
            //  else {
            // 保证水流未加载成功也能正常点击到模型
            pickObj = viewer.scene.pick(e.position);
            if (Cesium.defined(pickObj)) {
              try {
                if (!!pickObj) {
                  initProps(pickObj)
                }
              }
              catch { (err) => { console.log(err); } }
            }
            // }
            // })
          })




        })
      }
    },

    askSetLoadData (name) {
      setTimeout(() => {
        if (this.$refs.lmInfoId != undefined) {
          this.$refs.lmInfoId.setNewData(name);
        } else {
          this.askSetLoadData(name);
        }
      })
    },

    /**
     * 添加城市模型
     */
    addCityModel () {
      let that = this;

      // return new Promise((resolve, reject) => {
      //   let options = {
      //     id: '城市白膜',
      //     name: null,
      //     url: '../../assets/3Dtiles/test/tileset.json',
      //     scale: 6.8,
      //     property: null,
      //     posdifferent: null,
      //     rotate: null,
      //     isfixrotate: null
      //   }

      //   //加载3dtiles
      //   gisCore.model.createTileset('../../assets/3Dtiles/changshaCityModel/tileset.json', options).then(cityLeft => {
      //     gisCore.model.changeModelPos(cityLeft, [113.12098820449636, 28.256150218457687, 26], [0, 0, -90], [23.8, 23.8, 23.8])
      //     // window.cityLeft = cityLeft;
      //     that.recallFunc();
      //     resolve();
      //   })
      // })

      return new Promise((resolve, reject) => {
        this.askSetLoadData('城市模型');
        // 使用GIS数据库存储周边模型
        gisCore.database.get(this.cityModelUrl).then(blob => {
          const url = URL.createObjectURL(new Blob([blob]));
          //  留作左侧模型
          gisCore.model.addGltf({
            lon: 0,
            lat: 0,
            height: 0
          }, {
            id: "城市白膜",
            name: null,
            url: url,
            scale: 6.8,
            property: null
          }).then(cityModel => {
            gisCore.model.changeModelPos(cityModel, this.cityAxiz, [90, 0, 0])
            this.cityModel = cityModel;
          }).then(() => {
            // // 使用GIS数据库存储道路模型
            gisCore.database.get(this.roadModelUrl).then(blob => {
              const url = URL.createObjectURL(new Blob([blob]));
              // 留作主干道路
              gisCore.model.addGltf({
                lon: 0,
                lat: 0,
                height: 0
              }, {
                id: "城市道路",
                name: null,
                url: url,
                scale: 6.8,
                property: null
              }).then(roadModel => {
                this.roadModel = roadModel;
              }).then(() => {
                that.recallFunc();
              }).then(() => {
                resolve()
              })
            })
          }).then(() => {
            this.askSetLoadData('管道模型');
            // //加载3dtiles
            // let options = {
            //   id: '城市管道',
            //   name: null,
            //   url: '../../assets/3Dtiles/pipeModel/tileset.json',
            //   scale: 16.8,
            //   property: null,
            //   posdifferent: null,
            //   rotate: null,
            //   isfixrotate: null
            // }
            // gisCore.model.createTileset('../../assets/3Dtiles/test/tileset.json', options).then(pipeModel => {
            //   gisCore.model.changeModelPos(pipeModel, [113.12120020449636, 28.256050218457687, 200], [90, 0, 90])
            //   window.viewer.flyTo(pipeModel)
            //   that.recallFunc();
            //   resolve();
            // })

            // 使用GIS数据库存储道路模型
            gisCore.database.get(this.pipeModelUrl).then(blob => {
              const url = URL.createObjectURL(new Blob([blob]));
              // 留作主干道路
              gisCore.model.addGltf({
                lon: 0,
                lat: 0,
                height: 0
              }, {
                id: "城市管道",
                name: null,
                url: url,
                scale: 0.97,
                property: null
              }).then(pipeModel => {
                gisCore.model.changeModelPos(pipeModel, [113.12120020449636, 28.256050218457687, 20], [0, 90, 0])
                this.pipeModel = pipeModel;





                let askChangePipeModel = (pipeModel) => {
                  return new Promise((resolve, reject) => {
                    this.changePipeModel(pipeModel)
                    resolve()
                  }).catch(() => {
                    setTimeout(() => {
                      askChangePipeModel(pipeModel)
                    }, 300)
                  })
                }

                // 修改管道初始颜色
                setTimeout(async () => {
                  await askChangePipeModel(pipeModel)
                })

                // 1s后创建标签及动态水流线条
                setTimeout(async () => {
                  let wellAxiz = await this.addTips(pipeModel)
                  this.initMaterialLine(wellAxiz)
                }, 1000)

                // 隐藏加载模型框
                this.isShowLoadModelBox = false;

              }).then(() => {
                that.recallFunc();
              }).then(() => {
                resolve()
              })

            })

          })

        }
        )

      })



    },

    /**
     * 所需运行回调函数
     */
    recallFunc () {
      // 挂接数据
      setTimeout(() => {
        gisCore.model.attachGltfset(window.viewer)
      })
      // 隐藏部分标签
      setTimeout(() => {
        gisCore.tip.hideTipById('管内底埋深', true);
      })
      // 模型显隐按钮初始化
      setTimeout(() => {
        this.modelOptions = gisCore.model.getPrimitivesName();
        this.checkboxGroup = this.modelOptions;
      })
    },



    /**
     * 获取当前时间
     */
    getTime () {
      const now = new Date();
      const year = now.getFullYear();
      const month = ('0' + (now.getMonth() + 1)).slice(-2);
      const day = ('0' + now.getDate()).slice(-2);
      const hours = ('0' + now.getHours()).slice(-2);
      const minutes = ('0' + now.getMinutes()).slice(-2);
      const seconds = ('0' + now.getSeconds()).slice(-2);

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },


    /**
     * 水位模拟
     * @param {*} bool  
     */
    showPWLevel (bool, alertLevel = 0) {
      // l1: 0%~25%
      // l2: 25%~50%
      // l3: 50%~75%
      // l4: 75%~100%
      let curColor = '';
      var pwColorList = this.$refs.pwSetId.getColor();
      var pipeModel = this.pipeModel;
      // 防止颜色被清空导致报错
      pwColorList = pwColorList.map((e) => { if (e === null) { e = '#ffffff' } return e })





      if (bool) {

        let lastPickId = null
        for (var i in pipeModel._pickIds[0]['_pickObjects']) {
          if (!!pipeModel._pickIds[0]['_pickObjects'][i]['detail']?.node.show) {
            let pickObj = pipeModel._pickIds[0]['_pickObjects'][i]
            let temp = pickObj['detail'].node

            // 处理一些不需要高亮的模型元组
            if (temp._name === '项目总图' || temp._name === '道路') continue;

            // 利用pickID获取管道ID
            let id = pickObj.detail.node._id;
            let pickItem = pickObj.detail.model._loader._gltfJsonLoader._gltf.nodes[id].extras.Parameters.find((e) => { return e.GroupName === "标识数据" })

            // 处理pickItem为undefined的情况
            if (pickItem == undefined) continue;

            let pickID = pickItem['Parameters'][0]['value']

            // 处理pickID重复的情况
            if ((!!lastPickId || lastPickId === 0) && lastPickId == pickID) {
              continue;
            }
            lastPickId = pickID

            let pwLevel = this.queryPWLevel(pickID);
            if (pwLevel <= 0.25) {
              curColor = pwColorList[0];
            } else if (pwLevel <= 0.5) {
              curColor = pwColorList[1];
            } else if (pwLevel <= 0.75) {
              curColor = pwColorList[2];
            } else {
              curColor = pwColorList[3];
            }

            let CartesianColor = new Cesium.Cartesian3(Cesium.Color.fromCssColorString(curColor).red, Cesium.Color.fromCssColorString(curColor).green, Cesium.Color.fromCssColorString(curColor).blue);
            temp.runtimePrimitives[0].primitive.material.metallicRoughness.baseColorFactor = Object.freeze(new Cesium.Cartesian4(CartesianColor.x, CartesianColor.y, CartesianColor.z, 1));

            // 设置警告提醒
            if (alertLevel > 0 && pwLevel > alertLevel / 100) {
              this.pipeInfo.getPipeNameById(pickID).then((res) => {
                this.$notify({
                  title: '警告',
                  message: `【${res}】水位大于${alertLevel}%。\n（水位：${(pwLevel * 100).toFixed(1)}%；时间：${this.getTime()}）`,
                  type: 'warning',
                  duration: 0
                });

              }).catch(() => {
              })






            }

          }
        }


      } else {
        this.changePipeModel(pipeModel)
      }














    },

    /**
     * 根据管道ID查询对应的水位情况，返回水位值百分比（小数）
     * @param {*} data 
     */
    queryPWLevel (id) {
      // TODO:根据获取到的pipeID查询对应的水位情况，最后返回水位值百分比（小数


      // 这里临时返回测试数据
      var temp = Math.random() / 1.5;
      if (temp > 0.666) return temp + Math.random() / 3;
      return temp;
    },


    /**
     * 按要求修改当前管道项目构件各信息
     * @param {*} model 
     * @param {*} e 
     * @param {*} fixColor 
     */
    changePipeModel (pipeModel, fixColor = null) {

      let lastPickId = null
      for (var i in pipeModel._pickIds[0]['_pickObjects']) {
        if (!!pipeModel._pickIds[0]['_pickObjects'][i]['detail']?.node.show) {
          let pickObj = pipeModel._pickIds[0]['_pickObjects'][i]
          let temp = pickObj['detail'].node

          // 利用pickID获取管道ID
          let id = pickObj.detail.node._id;
          let pickItem = pickObj.detail.model._loader._gltfJsonLoader._gltf.nodes[id].extras.Parameters.find((e) => { return e.GroupName === "标识数据" })

          // 处理pickItem为undefined的情况
          if (pickItem == undefined) {
            continue;
          }
          let pickID = pickItem['Parameters'][0]['value']

          // 处理pickID重复的情况
          if ((!!lastPickId || lastPickId === 0) && lastPickId == pickID) {
            continue;
          }
          lastPickId = pickID

          this.pipeInfo.getPipeNameById(pickID).then((res) => {
            let pickName = res;

            if (pickName.slice(0, 2) == '雨水') fixColor = "#00398f"
            if (pickName.slice(0, 2) == '污水') fixColor = "#8e008f"
            if (pickName.slice(3, 6) == '检查井' || pickName.slice(3, 6) == '雨水口') fixColor = "#ffffff"

            let CartesianColor = new Cesium.Cartesian3(Cesium.Color.fromCssColorString(fixColor).red, Cesium.Color.fromCssColorString(fixColor).green, Cesium.Color.fromCssColorString(fixColor).blue);
            temp.runtimePrimitives[0].primitive.material.metallicRoughness.baseColorFactor = Object.freeze(new Cesium.Cartesian4(CartesianColor.x, CartesianColor.y, CartesianColor.z, 1));



          }).catch(() => {
          })


        }
      }

    },

    /**
     * 根据鼠标位置获取经纬度
     * @param {*} e 
     */
    mouseClick (e) {
      // 检测是否挖地
      this.changeDig();
      /**
       * 同步构件显隐按钮设置
       */
      setTimeout(() => {
        // 防遮挡
        if (this.isShowCheckbox == window.isShowCheckbox && this.isShowCheckbox) {
          window.isShowCheckbox = false;
        }
        if (this.isShowSettingbox == window.isShowSettingbox && this.isShowSettingbox) {
          window.isShowSettingbox = false;
        }
        this.isShowCheckbox = window.isShowCheckbox;
        this.isShowSettingbox = window.isShowSettingbox;
      })

      /**
       * 获取鼠标位置经纬度
       */
      if (this.isGetAxis) {
        try {

          console.log(gisCore.position.screen2axis(window.viewer, e));
        }
        catch { }
      }

      /**
       * 模型剖切实现
       */
      if (this.isCutModel) {
        let setLineheight = 60;
        let mouseAxis = gisCore.position.screen2axis(window.viewer, e)
        if (window.isCutModel == undefined) {
          window.isCutModel = true;
        } else {
          if (this.mouseAxisList.length > 2) {
            gisCore.model.delLine("PaintLineCollecion", true);
          }

          this.mouseAxisList.push(mouseAxis)
          try {
            gisCore.model.paintLine("PaintLineCollecion", [this.mouseAxisList[this.mouseAxisList.length - 2], this.mouseAxisList[this.mouseAxisList.length - 1]], setLineheight);
            gisCore.model.paintLine("PaintLineCollecion", [this.mouseAxisList[0], this.mouseAxisList[this.mouseAxisList.length - 1]], setLineheight);
          } catch (error) { }
        }
      }
    },

    mouseMove (e) {
      /**
       * 模型剖切实现
       */
      if (this.isCutModel && this.mouseAxisList.length >= 1) {
        let setLineheight = 60;
        let mouseAxis = gisCore.position.screen2axis(window.viewer, e)
        if (window.isCutModel == undefined) {
          window.isCutModel = true;
        } else {
          gisCore.model.delLine("PaintMoveLineCollecion");
          gisCore.model.paintLine("PaintMoveLineCollecion", [this.mouseAxisList[this.mouseAxisList.length - 1], mouseAxis], setLineheight, "#ffffff");
          gisCore.model.paintLine("PaintMoveLineCollecion", [this.mouseAxisList[0], mouseAxis], setLineheight, "#ffffff");
        }
      }
    },

    rightClick (e) {
      if (this.isCutModel) {
        this.$refs.cmSetId.endClick(e.ctrlKey);
      }
    },




    /**
     * 挖地控制
     */
    changeDig () {
      /**
       * 检测是否点击自动挖地按钮
       */
      if (this.isDig != window.isDig) {
        this.isDig = window.isDig
        let model = window.gisCore.model;
        if (this.isDig) {
          // 切割城市白膜
          model.cutModel(this.cityModel, this.cityCutAxiz, false, [90, 0, 0], undefined, undefined, 0)

          // 开启管道显示
          this.$refs.showCheck.$el.childNodes.forEach((ele) => {
            if (['城市白膜', '城市道路'].indexOf(ele.children[1].innerText) == -1) {
              this.switchShowCheck(ele.children[1].innerText, false)
            }
          })

          // 智能跟随挖地效果关闭城市道路显示
          this.switchShowCheck('城市道路', true)
          // // 关闭全球光照
          // window.viewer.scene.globe.enableLighting = false;
          // window.viewer.shadows = false
        } else {
          model.digModel(this.cityModel)

          // 解决道路自动显示bug
          gisCore.model.changeModelPos(this.roadModel, [113.12098820449636, 28.256150218457687, 26], [90, 0, 0])

          // 关闭管道显示
          this.$refs.showCheck.$el.childNodes.forEach((ele) => {
            if (['城市白膜', '城市道路'].indexOf(ele.children[1].innerText) == -1) {
              this.switchShowCheck(ele.children[1].innerText, true)
            }
          })

          // 智能跟随挖地效果开启城市道路显示
          this.switchShowCheck('城市道路', false)

          // // 开启全球光照
          // window.viewer.scene.globe.enableLighting = true;
          // window.viewer.shadows = true
        }
      }
    },

    /**
     * 构件显隐
     */
    showModel () {
      window.gisCore.model.setPrimitivesShow(this.checkboxGroup)
    },

    /**
    * 更多设置点击事件
    */
    clickSetting () {
      // 判断是否存储各个设置当前布尔值
      if (this.settingBoolDict === undefined) {
        this.settingBoolDict = {};
        this.initSetting();
      }

      setTimeout(() => {
        this.$refs.settingCheck.$el.childNodes.forEach((e) => {
          if (e.ariaChecked == null) {
            this.settingBoolDict[e.textContent] === false ? null : this.updateSetting(e.textContent, false);
            this.settingBoolDict[e.textContent] = false;
          } else {
            this.settingBoolDict[e.textContent] === true ? null : this.updateSetting(e.textContent, true);
            this.settingBoolDict[e.textContent] = true;
          }

        })
      })
    },

    /**
     * 更多设置初始化方法
     */
    initSetting () {
      setTimeout(() => {
        this.$refs.settingCheck.$el.childNodes.forEach((e) => {
          this.settingBoolDict[e.textContent] = false;
        })
      })
    },

    /**
     * 切换构件显隐单个模块
     * @param {*} name 
     * @param {*} bool 
     */
    switchShowCheck (name, bool) {
      try {
        if (!bool) {
          setTimeout(() => {
            this.$refs.showCheck.$el.childNodes.forEach((ele) => {
              if (ele.children[1].innerText === name && ele.attributes[2].value == 'el-checkbox-button el-checkbox-button--mini') {
                ele.click();
              }
            })
          })
        } else {
          setTimeout(() => {
            this.$refs.showCheck.$el.childNodes.forEach((ele) => {
              if (ele.children[1].innerText === name && ele.attributes[2].value != 'el-checkbox-button el-checkbox-button--mini') {
                ele.click();
              }
            })
          })
        }
      } catch (error) {

      }
    },

    /**
     * 切换更多设置单个模块
     * @param {*} name 
     * @param {*} bool 
     */
    switchSettingCheck (name, bool) {
      if (!bool) {
        setTimeout(() => {
          this.$refs.settingCheck.$el.childNodes.forEach((ele) => {
            if (ele.children[1].innerText === name && ele.attributes[2].value == 'el-checkbox-button el-checkbox-button--mini') {
              ele.click();
            }
          })
        })
      } else {
        setTimeout(() => {
          this.$refs.settingCheck.$el.childNodes.forEach((ele) => {
            if (ele.children[1].innerText === name && ele.attributes[2].value != 'el-checkbox-button el-checkbox-button--mini') {
              ele.click();
            }
          })
        })
      }
    },

    /**
     *  创建流动水线(水流模拟)
     */
    initMaterialLine (wellAxiz) {
      this.waterDirection.forEach((e) => {
        for (let i = 1; i < e.length; i++) {
          // console.log(e[i - 1] + ' - ' + e[i]);
          let axisStart = wellAxiz[e[i - 1]];
          let axisEnd = wellAxiz[e[i]];
          this.generalMaterialLine([axisStart[0], axisStart[1], axisStart[2] - 5], [axisEnd[0], axisEnd[1], axisEnd[2] - 5])
        }

      })
      this.recallFunc()

    },

    /**
     * 生成流动水线
     * @param {*} axisStart 
     * @param {*} axisEnd 
     */
    generalMaterialLine (axisStart, axisEnd) {
      window.gisCore.model.createMaterialLine(axisStart, axisEnd)
    },

    /**
     * 检查用户浏览器是否为推荐浏览器
     */
    checkAgent () {
      const explorer = window.navigator.userAgent.toLowerCase()
      if (explorer.indexOf("chrome") == -1) {
        // 提示需要推荐浏览器
        this.dialogText[0] = '当前使用的非推荐浏览器'
        this.dialogText[1] = '建议使用Chrome、Edge浏览器访问。'
        this.dialogVisible = true;
        return false;
      }

      // qq浏览器本质也是chrome，对面qq浏览器打开报错，因此这里需要用qq浏览器测试效果
      if (explorer.indexOf("qqbrowser") >= 0) {
        // 提示需要推荐浏览器
        this.dialogText[0] = '当前使用的非推荐浏览器'
        this.dialogText[1] = '建议使用Chrome、Edge浏览器访问。'
        this.dialogVisible = true;
        return false;
      }
      return true;

    },

    /**
     * 初次打开时提示配置
     */
    warnGpu () {
      if (window.localStorage.getItem('isReadWarnGpu') === null) {
        this.dialogText[0] = '首次打开提示'
        this.dialogText[1] = '推荐使用显卡GTX 1060及更高配置以获得更好浏览体验。'
        this.dialogVisible = true;
        window.localStorage.setItem('isReadWarnGpu', true);
      }
    }


  }

}
</script>
<style lang='less' scoped>
::v-deep .el-checkbox-button__inner {
  background: #ffffff80;
  color: #00000080;
}
::v-deep .el-checkbox-button__inner:hover {
  color: #f8f8f8c5;
}
::v-deep .el-checkbox-button.is-focus .el-checkbox-button__inner {
  border-color: #ffffff4d;
}
::v-deep .el-checkbox-button.is-checked:first-child .el-checkbox-button__inner {
  border-left-color: #ffffff4d;
}
::v-deep .el-checkbox-button.is-checked .el-checkbox-button__inner {
  color: #ffffff;
  background-color: #00000080;
  border-color: #ffffff4d;
  box-shadow: -1px 0 0 0 #00000080;
  border-radius: 10px;
  backdrop-filter: blur(10px);
}
::v-deep .el-checkbox-button--mini .el-checkbox-button__inner,
::v-deep .el-checkbox-button:first-child .el-checkbox-button__inner,
::v-deep .el-checkbox-button:last-child .el-checkbox-button__inner {
  border-radius: 10px;
  backdrop-filter: blur(10px);
}

.backs {
  color: #ffffff;
  position: absolute;
  right: 48px;
  top: 24px;
  cursor: pointer;
  display: none;
}
.title-info {
  width: 100%;
  color: #9ea3ad;
  position: absolute;
  z-index: 1;
  margin: 36px 0 0 58px;
  pointer-events: none;
}
.top-project {
  margin-bottom: 68px;
}
.l-title {
  font-size: 36px;
  font-weight: bold;
  text-shadow: 1px 1px #000;
  color: #ffffff;
  float: left;
}
.r-info {
  font-size: 14px;
  color: #9ea3ad;
  position: absolute;
  right: 116px;
  margin-top: 16px;
}
.m-r-24 {
  margin-right: 24px;
}
</style>
